import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BlobStorageService } from 'src/app/_modules/shared/_services/blob-storage.service';
import { AssetStatusEnum } from 'src/app/models/assetStatus.model';
import { ContainerNames } from 'src/app/models/containerNames.model';
import { HistoryOutput } from 'src/app/models/history.model';
import { ImageType } from 'src/app/models/image.model';
import { EditMvPole, MvPoleSave, PoleCondition, PoleShape, PoleStructure, PoleType } from 'src/app/models/mv-pole.model';
import { User } from 'src/app/models/user.model';
import { MvPoleService } from 'src/app/services/mv-pole.service';
import { PermissionsService } from 'shared-lib';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-edit-mv-poles',
  templateUrl: './edit-mv-poles.component.html',
  styleUrls: ['./edit-mv-poles.component.scss']
})
export class EditMvPolesComponent implements OnInit {
  @ViewChild('closeAudit') auditReviewModal: ElementRef;
  @ViewChild('closeModal') closeModal: ElementRef;
  
  id: number = 0;
  selectedMvPole: EditMvPole = new EditMvPole();
  latitude: number = 0;
  longitude: number = 0;
  mvPoleType: string = '';
  mvPoleShape: string = '';
  mvPoleCondition: string = '';
  mvPoleStructure: string = '';
  recallAssignedAllowed: boolean = false;
  recallValidatedAllowed: boolean = false;
  showRecallMenu: boolean = false;
  isMapVisible: boolean = false;
  isImageMapVisible: boolean = false;
  openUpdateDescriptionModal?: ElementRef;
  history: HistoryOutput = new HistoryOutput();
  mvPoleImage?: File | null;
  editEnabled: boolean = false;
  ImageType = ImageType;
  selectedImage: any;
  currentRotation: number = 0;
  imgZoomFullContainer: any;
  imgElement: any;
  AssetAssignType = AssetStatusEnum;
  assetAssignType: AssetStatusEnum;
  filterText: string = '';
  mobileUsers: User[] = [];
  isDropdownOpened: boolean = false;
  tempAssignedUserId: number = 0;
  isDataQuality: boolean = false;
  hasCimDataIntegration: boolean = false;

  mvPoleTypeOptions = [
    {
      name: PoleType[PoleType.Concrete],
      value: 1,
      translation: 'MV_POLES.TYPE.CONCRETE',
    },
    {
      name: PoleType[PoleType.Wooden],
      value: 2,
      translation: 'MV_POLES.TYPE.WOODEN',
    },
    {
      name: PoleType[PoleType.Steel],
      value: 3,
      translation: 'MV_POLES.TYPE.STEEL',
    },
  ];

  mvPoleShapeOptions = [
    {
      name: PoleShape[PoleShape.Round],
      value: 1,
      translation: 'MV_POLES.SHAPE.ROUND',
    },
    {
      name: PoleShape[PoleShape.Square],
      value: 2,
      translation: 'MV_POLES.SHAPE.SQUARE',
    },
  ];

  mvPoleConditionOptions = [
    {
      name: PoleCondition[PoleCondition.Good],
      value: 1,
      translation: 'MV_POLES.CONDITION.GOOD',
    },
    {
      name: PoleCondition[PoleCondition.BentLeaning],
      value: 2,
      translation: 'MV_POLES.CONDITION.BENT',
    },
    {
      name: PoleCondition[PoleCondition.Vandalized],
      value: 3,
      translation: 'MV_POLES.CONDITION.VANDALIZED',
    },
  ];

  mvPoleStructureOptions = [
    {
      name: PoleStructure[PoleStructure.HPole],
      value: 1,
      translation: 'MV_POLES.STRUCTURE.HPOLE',
    },
    {
      name: PoleStructure[PoleStructure.Single],
      value: 2,
      translation: 'MV_POLES.STRUCTURE.SINGLE',
    },
    {
      name: PoleStructure[PoleStructure.ThreePoles],
      value: 3,
      translation: 'MV_POLES.STRUCTURE.THREE_POLES',
    },
    {
      name: PoleStructure[PoleStructure.FourPoles],
      value: 4,
      translation: 'MV_POLES.STRUCTURE.FOUR_POLES',
    },
  ];

  constructor(
    private mvPoleService: MvPoleService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private renderer: Renderer2,
    private blobStorageService: BlobStorageService,
    private userService: UserService,
    public permissionsService: PermissionsService,
    private authService: AuthService,
  ) {
    this.hasCimDataIntegration = this.authService.hasCimDataIntegration;
  }

  ngOnInit(): void {
    this.id = parseInt(this.route.snapshot.paramMap.get('id') || '');
    this.getSelectedMvPole(this.id);
    this.blobStorageService.setContainer(ContainerNames.Images);
  }

  getSelectedMvPole(id: number) {
    this.mvPoleService.getById(id).subscribe({
      next: (data) => {
        this.selectedMvPole = new EditMvPole(data?.body?.data);
        this.selectedMvPole.images = data?.body?.data.images!;
        this.latitude = this.selectedMvPole.latitude;
        this.longitude = this.selectedMvPole.longitude;
        this.mvPoleType = this.mvPoleTypeOptions!.find(
          (x) => x.name == this.selectedMvPole.poleType
        )!.translation;
        this.mvPoleShape = this.mvPoleShapeOptions!.find(
          (x) => x.name == this.selectedMvPole.poleShape
        )!.translation;
        this.mvPoleCondition = this.mvPoleConditionOptions!.find(
          (x) => x.name == this.selectedMvPole.poleCondition
        )!.translation;
        this.mvPoleStructure = this.mvPoleStructureOptions!.find(
          (x) => x.name == this.selectedMvPole.poleStructure
        )!.translation;
        if (this.selectedMvPole.status === 'Assigned') {
          this.recallAssignedAllowed = true;
        }

        if (this.selectedMvPole.dataQualityId !== 0) {
          this.recallValidatedAllowed = true;
        }
      },
      error: (err) => {
        this.toastr.error('An error ocurred.');
      },
    });
  }

  getImageByType(imageType: ImageType) {
    return this.selectedMvPole.images?.find(
      (x) =>
        ImageType[x.imageType.toString() as keyof typeof ImageType] == imageType
    );
  }

  getMountedTagImage() {
    return this.selectedMvPole.images?.find(
      (x) =>
        ImageType[x.imageType.toString() as keyof typeof ImageType] ==
        ImageType.MountedTag
    )?.url;
  }

   getMvPoleCrossArmImage() {
    return this.selectedMvPole.images?.find(
      (x) =>
        ImageType[x.imageType.toString() as keyof typeof ImageType] ==
        ImageType.MvPoleCrossArm
    )?.url;
  }

   getMvPoleLeftImage() {
    return this.selectedMvPole.images?.find(
      (x) =>
        ImageType[x.imageType.toString() as keyof typeof ImageType] ==
        ImageType.MVPoleLeft
    )?.url;
  }

  getMvPoleRightImage() {
    return this.selectedMvPole.images?.find(
      (x) =>
        ImageType[x.imageType.toString() as keyof typeof ImageType] ==
        ImageType.MVPoleRight
    )?.url;
  }

  showImage(imageType: ImageType) {
    switch (imageType) {
       case ImageType.MountedTag:
        this.selectedImage = this.getImageByType(ImageType.MountedTag);
        break;
      case ImageType.MVPoleLeft:
        this.selectedImage = this.getImageByType(ImageType.MVPoleLeft);
        break;
      case ImageType.MVPoleRight:
        this.selectedImage = this.getImageByType(ImageType.MVPoleRight);
        break;
      case ImageType.MvPoleCrossArm:
        this.selectedImage = this.getImageByType(ImageType.MvPoleCrossArm);
        break;
      default:
        this.selectedImage = undefined;
    }
  }

  edit() {
    this.editEnabled = true;
  }

  onModalFade() {
    this.currentRotation = 0;

    if (this.imgZoomFullContainer) {
      var displayValue = getComputedStyle(this.imgZoomFullContainer).display;

      if (displayValue == 'block') {
        this.imgElement.click();
      }
    }
  }

  onModalOpen() {
    this.renderer.setStyle(document.body, 'overflow', 'auto');
    this.renderer.setStyle(document.body, 'overflow-x', 'hidden');
    this.renderer.setStyle(document.body, 'padding-right', '0');
  }

  rotateLeft() {
    this.currentRotation -= 90;
  }

  rotateRight() {
    this.currentRotation += 90;
  }

  disableUpdateStatusButton() {
    if (this.selectedMvPole.dataQualityId === 0) return false;
    else return true;
  }

  save() {
    let saveModel = new MvPoleSave();
    saveModel.poleNumber = this.selectedMvPole.poleNumber;
    saveModel.poleType = this.selectedMvPole.poleType;
    saveModel.address = this.selectedMvPole.address;
    saveModel.closestLandmark = this.selectedMvPole.landmark;
    saveModel.poleShape = this.selectedMvPole.poleShape;
    saveModel.poleCondition = this.selectedMvPole.poleCondition;
    saveModel.poleStructure = this.selectedMvPole.poleStructure;
    saveModel.id = this.selectedMvPole.id;
    saveModel.history = this.selectedMvPole.history;

    this.mvPoleService.addOrUpdateMvPole(saveModel).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.editEnabled = false;
          this.toastr.success('Successfully edited pole');
          window.location.reload();
          this.openUpdateDescriptionModal?.nativeElement?.click();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  validateInput(event: Event) {
    if (!this.selectedMvPole.poleNumber) {
      this.toastr.error('MV Pole number can not be empty!');
      return;
    }
    if (!this.selectedMvPole.address) {
      this.toastr.error('MV Pole address can not be empty!');
      return;
    }

    this.openUpdateDescriptionModal?.nativeElement?.click();
  }

  updateHistory(history: any) {
    this.history = history;
    this.selectedMvPole.history = this.history;

    this.save();
  }

  fileBrowserHandler({
    file,
    type,
    imageId,
  }: {
    file: File;
    type: ImageType;
    imageId: number;
  }) {
    if (!file) {
      this.toastr.error('Image data is missing');
      return;
    }

    this.mvPoleImage = file;

    this.blobStorageService.uploadFile(
      this.mvPoleImage,
      this.mvPoleImage.name,
      (uploadedUrl) => {
        const obj = {
          imageType: type,
          poleId: this.selectedMvPole.id,
          guid: this.selectedMvPole.guid,
          url: uploadedUrl,
          imageId: imageId,
        };

        this.mvPoleService.uploadPicture(obj, this.mvPoleImage!).subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              const images = this.selectedMvPole.images.filter(
                (x) => x.imageType == type
              );
              const imageIndex = this.selectedMvPole.images.indexOf(
                images[imageId]
              );
              this.selectedMvPole.images[imageIndex] = responseData.data;
              this.toastr.success('Successfully added image');
              this.getSelectedMvPole(this.id);
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occurred while saving image metadata');
          },
        });
      },
      (error) => {
        console.error('Error uploading image to blob storage:', error);
        this.toastr.error('Failed to upload image to storage');
      }
    );
  }

  cancel() {
    this.auditReviewModal?.nativeElement?.click();
  }

  recall() {
    this.mvPoleService.recall(this.id).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success('Successfully recalled MV Pole.');
          window.location.reload();
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occured');
      },
    });
  }

  getMobileUsers() {
    this.userService
      .getMobileUsers(this.selectedMvPole.districtId, this.filterText)
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.mobileUsers = responseData.data;
            if (this.mobileUsers.length == 0) {
              this.isDropdownOpened = false;
            } else {
              this.isDropdownOpened = true;
            }
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occured');
        },
      });
  }

  setModalType(type: AssetStatusEnum) {
    this.assetAssignType = type;
  }

  onModalAssignFade() {
    this.filterText = this.selectedMvPole.assignedUser;
  }

  filterMobileUsers() {
    this.isDropdownOpened = true;
    this.tempAssignedUserId = 0;
    this.getMobileUsers();
  }

  openDropdown() {
    this.isDropdownOpened = true;
  }

  selectFieldAgent(id: number) {
    this.isDropdownOpened = false;
    this.selectedMvPole.assignedUserId = id;
    this.tempAssignedUserId = id;
    var mobUser = this.mobileUsers.find((x) => x.id == id);
    this.filterText = mobUser!.fullName;
  }

  assignTask(): void {
    if (
      this.mobileUsers.filter((x) => x.fullName == this.filterText.trim())
        .length > 0
    ) {
      this.selectedMvPole.assignedUserId = this.mobileUsers.filter(
        (x) => x.fullName == this.filterText.trim()
      )[0].id;
      this.tempAssignedUserId = this.selectedMvPole.assignedUserId;
    } else {
      this.tempAssignedUserId = 0;
    }
    if (this.tempAssignedUserId != 0) {
      this.mvPoleService
        .assignPole(
          this.selectedMvPole.id,
          this.selectedMvPole.assignedUserId,
          this.assetAssignType,
          this.isDataQuality
        )
        .subscribe({
          next: (response) => {
            const responseData = response.body;
            if (responseData?.status === 200 || responseData?.status === 'OK') {
              this.closeModal?.nativeElement?.click();
              this.toastr.success('Successfully assigned user');
              window.location.reload();
            } else {
              this.toastr.error(responseData?.message);
            }
          },
          error: (_) => {
            this.toastr.error('Error occured');
          },
        });
    } else {
      this.toastr.warning('Please select valid user.');
    }
  }
}